import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import {
  InlineOverlay,
  InlineOverlayHeader,
  InlineOverlayBody,
  InlineOverlayFooter,
  InlineOverlayCloseButton
} from '@bibliocommons/base-inline-overlay';
import { bibShape } from '@bibliocommons/bc-prop-types';
import BibBrief from 'app/components/shared/BibBrief';
import { bindAll } from '@bibliocommons/utils-react';
import { PrimaryButton } from '@bibliocommons/deprecated-base-buttons';
import { Checkmark } from '@bibliocommons/deprecated-base-icons';

import HoldsPauseDateSelect from '../../HoldsPauseDateSelect';

import '../styles/BasePauseHoldWorkflowView.scss';

export default class BasePauseHoldWorkflowView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      suspendDates: {
        startDate: props.initialSuspendStartDate || null,
        endDate: props.initialSuspendEndDate || null
      }
    };

    bindAll(this);
  }

  handlePauseUpdate() {
    const { suspendDates } = this.state;
    this.props.handleHoldPauseDate(suspendDates);
  }

  renderBibInfo() {
    const { bibs, holdIds } = this.props;
    const bib = bibs.first();
    const showBrief = holdIds.size === 1 && bib;

    return showBrief && <BibBrief bib={bib} titleTag="h3" renderTitleAsLink={false} renderAuthorsAsLink={false} />;
  }

  render() {
    const { startDate, endDate } = this.state.suspendDates;
    const { isLoading, handleClose, enableStartDate, enableEndDate } = this.props;

    return (
      <div className="cp-base-pause-hold-workflow-view">
        <InlineOverlay handleClose={handleClose}>
          <InlineOverlayHeader>
            <FormattedMessage id="pause_confirmation_hold_title" />
          </InlineOverlayHeader>
          <InlineOverlayBody>
            {this.renderBibInfo()}
            <FormattedMessage id="pause_workflow_info_text" />
            <div className="cp-pause-hold-workflow-date item-row">
              <HoldsPauseDateSelect
                fullScreen
                enableStartDate={enableStartDate}
                enableEndDate={enableEndDate}
                initialSuspendStartDate={this.props.initialSuspendStartDate}
                initialSuspendEndDate={this.props.initialSuspendEndDate}
                onSelectDates={suspendDates => this.setState({ suspendDates })}
              />
            </div>
          </InlineOverlayBody>
          <InlineOverlayFooter>
            <div className="col-12 col-xs-12">
              <PrimaryButton
                className="pull-right"
                isLoading={isLoading}
                handleClick={this.handlePauseUpdate}
                disabled={(!startDate && enableStartDate) || (!endDate && enableEndDate)}
              >
                <Checkmark color="#FFF" /> <FormattedMessage id="pause_confirmation_hold_button_yes" />
              </PrimaryButton>
              <InlineOverlayCloseButton className="btn btn-link pull-right">
                <FormattedMessage id="button_nevermind_close" />
              </InlineOverlayCloseButton>
            </div>
          </InlineOverlayFooter>
        </InlineOverlay>
      </div>
    );
  }
}

BasePauseHoldWorkflowView.propTypes = {
  bibs: ImmutablePropTypes.listOf(bibShape).isRequired,
  handleClose: PropTypes.func.isRequired,
  holdIds: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      holdId: PropTypes.string
    })
  ),
  handleHoldPauseDate: PropTypes.func.isRequired,
  initialSuspendStartDate: PropTypes.string,
  initialSuspendEndDate: PropTypes.string,
  enableStartDate: PropTypes.bool,
  enableEndDate: PropTypes.bool,
  isLoading: PropTypes.bool
};
